import { FC, useId } from 'react'
import { useEssentials } from 'hooks/utils/useEssentials'
import { TRANSLATION_KEYS } from 'locales/translation-keys'
import { Card, Grid } from '@design-systems/canvas-ui'
import Icon, { AiGenSimpleFillIcon } from '@design-systems/react-icons'
import { NoData } from '../no-data/no-data'

interface FunFactsProps {
    data: string[]
}

export const FunFacts: FC<FunFactsProps> = ({ data }) => {
    const { t } = useEssentials()
    const { insights } = TRANSLATION_KEYS
    const headingId = useId()
    return (
        <section aria-labelledby={headingId}>
            <h2 id={headingId} className="hc8-mb-3x hc8-fs-250">
                {t(insights.funFacts.header)}
            </h2>
            <Card className="hc8-pa-4x">
                <img
                    src="/insights/Bullseye.svg"
                    alt=""
                    aria-hidden="true"
                    className="hc8-wth-100"
                />
                <Grid.Container
                    direction="column"
                    className="hc8-mt-4x"
                    spacing="expanded"
                >
                    {data.length === 0 ? (
                        <NoData />
                    ) : (
                        data.map((fact, index) => (
                            <Grid.Item
                                key={index}
                                data-testid="fun-fact-item"
                                className="hc8-fs-050 hc8-clr-disabled"
                            >
                                <Grid.Container direction="row" noWrap>
                                    <Grid.Item>
                                        <Icon
                                            svg={AiGenSimpleFillIcon}
                                            aria-hidden={true}
                                        />
                                    </Grid.Item>
                                    <Grid.Item>{fact}</Grid.Item>
                                </Grid.Container>
                            </Grid.Item>
                        ))
                    )}
                </Grid.Container>
            </Card>
        </section>
    )
}
